import FadeIn from "react-fade-in";
import styled from "styled-components";
import { Color } from "../../theme/Color";

const StyledChildMenu = styled.div`
  background: ${Color.White};
  width: 200px;
  position: absolute;
  top: 76px;
  z-index: 99999;
  -webkit-border-bottom-right-radius: 5px;
  -webkit-border-bottom-left-radius: 5px;
  -moz-border-radius-bottomright: 5px;
  -moz-border-radius-bottomleft: 5px;
  border-bottom-right-radius: 5px;
  border-bottom-left-radius: 5px;

  & a {
    min-width: 200px;
    border-radius: 0;
  }
`;

const ChildMenu = (props) => {
  return (
    <StyledChildMenu>
      <FadeIn>{(props.showMenu && <div>{props.children}</div>) || null}</FadeIn>
    </StyledChildMenu>
  );
};

export default ChildMenu;
